
import {mapMutations} from 'vuex'
import Fly from 'flyio/dist/npm/fly'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {authLogin, fetchUser, authRegister} from '@/api/user'
import {setCookie} from '@/utils/index'

export default {
components: {
XInput,
Group,
XButton

},
data () {
return {
loginModel: {
tabIndex: 0,
mobile: '',
password: '',
identity: 'advertiser',
captcha: '',
captcha_token: '',
captcha_sms: '',
scope: 'mobile_signup',
device: 'wap'
},
loginMode2: {
tabIndex: 0,
mobile: '',
password: '',
identity: 'advertiser',
captcha: '',
captcha_token: '',
captcha_sms: '',
scope: 'mobile_signup',
device: 'wap'
},
captchaImg: '',
smsCount: 0,
smsDisable: false
}
},

methods: {

changeTab (index) {
this.loginModel.tabIndex = index
console.log(index)
},

smsCountDown () {
const _this = this
_this.smsCount = 60
_this.smsDisable = true
let interval = window.setInterval(function () {
--_this.smsCount
if (_this.smsCount === 0) {
_this.smsDisable = false
window.clearInterval(interval)
}
}, 1000)
},
login () {
authLogin(this.loginMode2).then(res => {
setCookie('token', JSON.stringify(res.data.token))
fetchUser().then(resp => {
this.setProfile(resp.data)
})
this.$router.push('/me')
}).catch(e => {
this.$vux.toast.show({
text: e.message,
type: 'cancel'
})
this.getCaptcha()
this.loginMode2.captcha = ''
console.log('登录失败', e)
})
},

getTextCaptcha () {
if (!this.smsDisable) {
if (!this.loginModel.captcha) {
this.$vux.toast.show({
text: '请输入正确的验证码',
time: 1000
})
this.getCaptcha()
return false
} else if (!this.loginModel.mobile) {
this.$vux.toast.show({
text: '请输入手机号',
time: 1000
})
return false
} else {
const textCaptchaModel = {
captcha: this.loginModel.captcha,
captcha_token: this.loginModel.captcha_token,
mobile: this.loginModel.mobile,
scope: 'mobile_signup'
}
let fly = new Fly() 
fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
method: 'post'
}).then(resp => {
if (!resp.data.success) {
this.getCaptcha()
} else {
this.smsCountDown()
}
this.$vux.toast.show({
text: resp.data.message,
time: 1000
})
}).catch((e) => console.log('获取短信验证码失败', e))
}
}
},

register () {
authRegister(this.loginModel).then(res => {
this.$vux.toast.show({
text: '注册成功',
time: 1000
})
this.$router.replace('/register-profile')
}).catch((e) => {
console.log('注册失败', e)
this.$vux.toast.show({
text: e.message,
type: 'cancel',
time: 1000
})
})
},

getCaptcha () {
let fly = new Fly() 
fly.config.withCredentials = true  
fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
method: 'post'
}).then(resp => {
this.captchaImg = resp.data.data.src
this.loginModel.captcha_token = resp.data.data.captcha_token
this.loginMode2.captcha_token = resp.data.data.captcha_token
}).catch((e) => console.log('error', e))
}
},

...mapMutations({
setProfile: 'SET_PROFILE'
}),
getCaptcha () {
let fly = new Fly() 
fly.config.withCredentials = true  
fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
method: 'post'
}).then(resp => {
this.captchaImg = resp.data.data.src
this.loginMode2.captcha_token = resp.data.data.captcha_token
}).catch((e) => console.log('error', e))
},

mounted () {
this.getCaptcha()
}
}



// WEBPACK FOOTER //
// ./src/pages/login/index.vue